module.exports = __webpack_public_path__ + "static/media/neko-old-logo.7075da9b.png";